export default __webpack_public_path__ + "static/media/DNo.4-0.030d72b2.jpg";